import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

function Loading() {
  return (
    <Container>
      <div className="lds-ellipsis small">
        <div />
        <div />
        <div />
        <div />
      </div>
    </Container>
  );
}

export default Loading;
